export function scrollToTop(containerScrollClass: string, isAnimated = true) {
  const element = document.querySelector(`.${containerScrollClass}`);

  if (element) {
    element.scrollTo({
      top: 0,
      left: 0,
      ...(isAnimated && { behavior: 'smooth' })
    });
  }
}
